import { createRoutine, bindRoutineToReduxForm } from "redux-saga-routines";

// creating routine
export const fetchSalesDataRoutine = createRoutine("admin/FETCH_SALES_DATA");
export const salesDataFilterFormHandler = bindRoutineToReduxForm(
  fetchSalesDataRoutine
);

//export const getSalesDataRoutine = createRoutine('dfuse/GET_SALES_DATA');
